import type {SmsState} from 'src/types/sms';
import type {NodeSchedule} from 'src/types/node-schedule';
import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApiBff from 'src/utils/redux-api-bff';
import * as reduxApi from 'src/utils/redux-api-v2';
import {parseSms} from 'src/utils/sms';


export const RECEIVE_SMS_INFO = 'sms/receive';
export const UPDATE_SMS_INFO = 'sms/update';
export const UPDATE_NODE_SCHEDULE = 'sms/update-node-schedule';

export const RESET = 'sms/reset';

type UpdateSmsInfoPayload = Partial<SmsState>;

type ReceiveSmsInfoAction = {
  type: 'sms/receive';
  payload: SmsState;
};

type UpdateSmsInfoAction = {
  type: 'sms/update';
  payload: UpdateSmsInfoPayload;
};

type ResetStateAction = {
  type: 'sms/reset';
};

type UpdateNodeScheduleAction = {
  type: 'sms/update-node-schedule';
  payload: Partial<NodeSchedule>;
};

export type SmsAction =
  | ReceiveSmsInfoAction
  | UpdateSmsInfoAction
  | UpdateNodeScheduleAction
  | ResetStateAction;

export const reset = (): ResetStateAction => ({type: RESET});

export const receiveSmsNode = (payload: SmsState): ReceiveSmsInfoAction => ({
  type: RECEIVE_SMS_INFO,
  payload,
});

export const updateSmsInfo = (
  payload: UpdateSmsInfoPayload,
): UpdateSmsInfoAction => ({
  type: UPDATE_SMS_INFO,
  payload,
});

export const getSmsTaskNode: (id: string) => ThunkAction<unknown> =
  (id) => async (dispatch: Dispatch) => {
    const fetchedNodeResponse = await dispatch(
      reduxApiBff.get(`node/composite`, {
        node_id: id,
      }),
    );
    const parsedSmsNode = parseSms(fetchedNodeResponse.body);
    return dispatch(updateSmsInfo(parsedSmsNode));
  };

export const getProvisionedPhoneNumbers: (
  id: string | number,
) => ThunkAction<unknown> = (id) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.get(`provisioned-phone`, {
      associated_with_category: String(true),
      category_id: String(id),
    }),
  );
};

export const updateNodeSchedule = (
  payload: Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});
